import { Component, OnDestroy, OnInit, HostListener,ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { FotoService } from '../../../services/module-config/users/foto.service';
import { NotificationsService } from '../../../services/notifications/notifications.service';
import { SocketService } from '../../../services/../pages/productos/budget/services/socket.service';
//importa swal
import Swal from 'sweetalert2';
import { UsuariosService } from 'app/services/module-config/users/usuarios.service';
import { UserExternalService } from 'app/services/module-config/users/user.external.service';
import { FormControl } from '@angular/forms';
import { PermisosService } from 'app/services/module-config/permissions/permisos.service';
import { Subject, Subscription, debounceTime, distinctUntilChanged, finalize, takeUntil } from 'rxjs';
import { Meeting } from 'app/models/meetings/meeting.models';
import { MeetingService } from 'app/services/module-meetings/meeting.service';
import { AvatarAssistantService } from 'app/shared/components/avatar-assistant/avatar-assistant.service';
import {
  MeetingModalClosedEvent,
  MeetingModalInitialData,
  MeetingModalMode,
  MeetingModalSavedEvent,
} from 'app/shared/components/modals/meeting/meeting-modal-shared.component';

import { HttpClient } from '@angular/common/http';
import { toPng } from 'html-to-image';
import { environment } from '../../../../environments/environment';

export interface UiNotification {
  id: number;
  message: string;
  link?: string;
  createdAt: Date;
  closing?: boolean;
}

interface DigitalCardResponse {
  version: number;
  full_name: string;
  user_external_id: string | null;
  employee_external_id: string | null;
  employee_status: string | null;
  employee_enabled: boolean;
  user_active: boolean;
  qr_data_url: string;
  qr_format: string;
  identity_hint: string;
}

@Component({
  standalone: false,
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.css', './top-bar.directory.css'],
})
export class TopBarComponent implements OnInit, OnDestroy {
  uiNotifications: UiNotification[] = [];
  private notifId = 0;

  nombreUsuario: string = '';
  imagenPerfil: string = '';
  apellidosUsuario: string = '';
  menuAbierto: boolean = false;
  perfilCompleto: boolean | string = false;
  //notificaciones
  mostrarNotificaciones = false;
  notificaciones: any[] = [];
  notificacionesNoLeidas = 0;
  //var opaginacion notificaciones
  page = 1;
  limit = 10;
  loading = false;
  hasMore = true;
  filtro: 'todas' | 'no_leidas' = 'todas';

  photoActivate = true;
  directoryOpen = false;
  directoryUsers: any[] = [];
  directorySearch = new FormControl('');
  directoryIncludeInactive = false;
  directoryPage = 1;
  readonly directoryLimit = 20;
  directoryTotal = 0;
  directoryTotalPages = 0;
  directoryError = '';
  directoryCopyMessage = '';
  private directoryRequest?: Subscription;
  loadingDirectory = false;
  viewPhone = false;
  user_id: number = 0;

  employeeExternalId: string | null = null;

  myLodgingLoading = false;
  myLodgingError = '';
  myLodgingData: any | null = null;

  cargandoVantix = false;

  meetingsOpen = false;
  canViewMeetingsCenter = false;
  avatarVisible = false;
  meetingsLoading = false;
  meetingsSyncing = false;
  meetingsError = '';
  upcomingMeetings: Meeting[] = [];
  upcomingMeetingsTotal = 0;
  meetingModalOpen = false;
  meetingModalMode: MeetingModalMode = 'create';
  meetingModalExternalId: string | null = null;
  meetingModalInitialData: MeetingModalInitialData | null = null;

  private readonly destroy$ = new Subject<void>();
  private lastMicrosoftSyncAt = 0;

  @ViewChild('digitalCard', { static: false })
  digitalCardElement?: ElementRef<HTMLElement>;

  digitalCardOpen = false;
  digitalCardLoading = false;
  digitalCardDownloading = false;
  digitalCardError = '';
  digitalCardData: DigitalCardResponse | null = null;

  private previousBodyOverflow = '';

  secondaryCompany = false;
  constructor(
    private authService: AuthService,
    private router: Router,
    private fotoService: FotoService,
    private notificationsService: NotificationsService,
    private socketSvc: SocketService,
    private userService: UsuariosService,
    private permisosService: PermisosService,
    private userExternalService: UserExternalService,
    private meetingService: MeetingService,
    private avatarAssistantService: AvatarAssistantService,
    private http: HttpClient,
  ) {}

  ngOnInit(): void {
    this.secondaryCompany = this.authService.getUsuarioDesdeToken()?.secondary_company === true;
    if (this.secondaryCompany) return;
    this.loadEmployeePhoto();
    this.canViewPhone();
    this.directorySearch.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(() => {
        if (this.directoryOpen) this.loadDirectoryUsers(1);
      });

    this.avatarAssistantService.refreshForCurrentUser();
    this.avatarAssistantService.preferences$
      .pipe(takeUntil(this.destroy$))
      .subscribe((preferences) => {
        this.avatarVisible = preferences.enabled === true;
      });

    const usuario = this.authService.getUsuarioDesdeToken();
    this.loadMeetingsCenterAccess();
    this.userService.getEmployeeByUsuario().subscribe({
      next: (employee) => {
        this.employeeExternalId = employee?.external_id || null;
      },
      error: () => {
        this.employeeExternalId = null;
      },
    });
    if (usuario) {
      this.user_id = Number(usuario.id);
      this.nombreUsuario = usuario.nombre;
      this.apellidosUsuario = usuario.apellidos;
      this.perfilCompleto = String(usuario.perfil_completo) === 'true';

      if (this.photoActivate) {
      } else {
        this.imagenPerfil = usuario.id
          ? this.fotoService.obtenerFotoCarnetUrl(String(usuario.id))
          : '../../../../assets/img/default_user.png';
      }

      //     conecta socket y entra al room
      this.socketSvc.joinUserRoom(usuario.id);
    }
    // // 🔔    cargar preview inicial (HTTP)
    this.notificationsService.loadPreview(this.filtro);

    // 🔔     escuchar SOLO preview
    this.notificationsService.getPreviewStream().subscribe((res) => {
      this.notificaciones = res;
      this.notificacionesNoLeidas = res.filter((n) => !n.is_read).length;
    });

    // ⚡     realtime → preview
    this.socketSvc.onNotification().subscribe((notif) => {
      console.log('🔔 Notificación en tiempo real', notif);
      this.notificationsService.addPreviewNotificationRealtime(notif);

      setTimeout(() => {
        this.showUiNotification(notif);
      });
    });

    // // 🔄    cargar estado inicial (HTTP)
    // this.notificationsService.init(1, this.limit);

    // 🔄     escuchar stream (UNA SOLA FUENTE)
    // this.notificationsService.getNotificationsStream().subscribe((res) => {
    //   this.notificaciones = res;
    //   this.notificacionesNoLeidas = res.filter((n) => !n.is_read).length;
    // });

    // ⚡     escuchar socket (realtime)
    // this.socketSvc.onNotification((notif) => {
    //   console.log('🔔 Notificación en tiempo real', notif);
    //   //this.notificationsService.addNotificationRealtime(notif);
    //   this.notificationsService.addPreviewNotificationRealtime(notif);
    // });

    // 🔔 ESCUCHAR NOTIFICACIONES
    //q traigas las preview
    // this.notificationsService.getPreviewStream().subscribe((res: any) => {
    //   this.notificaciones = res;
    //   this.notificacionesNoLeidas = res.filter((n: any) => !n.is_read).length;
    // });
  }
  ngOnDestroy(): void {
    this.directoryRequest?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
    }

    if (this.digitalCardOpen) {
      document.body.style.overflow = this.previousBodyOverflow;
    }
  }

  private objectUrl: string | null = null;
  private loadEmployeePhoto(): void {
    const userId = this.authService.getUsuarioDesdeToken()?.user_secure_id;

    if (!this.photoActivate || !userId) {
      this.imagenPerfil = '../../../../assets/img/default_user.png';
      return;
    }

    this.userService.getPhoto(userId).subscribe({
      next: (blob: Blob) => {
        if (this.objectUrl) {
          URL.revokeObjectURL(this.objectUrl);
        }

        this.objectUrl = URL.createObjectURL(blob);
        this.imagenPerfil = this.objectUrl;
      },
      error: () => {
        this.imagenPerfil = '../../../../assets/img/default_user.png';
      },
    });
  }

  toggleMenu(): void {
    this.menuAbierto = !this.menuAbierto;

    if (
      this.menuAbierto &&
      this.employeeExternalId &&
      !this.myLodgingData &&
      !this.myLodgingLoading
    ) {
      this.loadMyLodging();
    }
  }

  cerrarSesion(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  toggleAvatar(event: MouseEvent): void {
    event.stopPropagation();
    const nextVisible = !this.avatarVisible;
    this.avatarAssistantService.updatePreferences({
      enabled: nextVisible,
    });

    if (nextVisible) {
      this.avatarAssistantService.unlockSound();
    }
  }

  openAvatarSettings(event: MouseEvent): void {
    event.stopPropagation();
    this.menuAbierto = false;
    this.router.navigate(['/configuraciones/avatar-asistente']);
  }

  toggleNotificaciones(event: MouseEvent) {
    event.stopPropagation();
    this.mostrarNotificaciones = !this.mostrarNotificaciones;

    // 👉 Si se abre la campana, recarga desde BD
    if (this.mostrarNotificaciones) {
      this.notificationsService.loadPreview(this.filtro);
    }
  }

  toggleMeetings(event: MouseEvent): void {
    event.stopPropagation();
    if (!this.canViewMeetingsCenter) return;
    this.meetingsOpen = !this.meetingsOpen;
    this.mostrarNotificaciones = false;
    this.menuAbierto = false;
    if (this.meetingsOpen) this.syncMicrosoftAndLoadUpcoming();
  }

  private loadMeetingsCenterAccess(): void {
    this.meetingService
      .getConfiguration()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (configuration) => {
          this.canViewMeetingsCenter =
            configuration.microsoft?.canCreateMeetings === true;
          if (!this.canViewMeetingsCenter) this.meetingsOpen = false;
        },
        error: () => {
          this.canViewMeetingsCenter = false;
          this.meetingsOpen = false;
        },
      });
  }

  syncMicrosoftAndLoadUpcoming(force = false): void {
    if (this.meetingsSyncing) return;
    if (!force && Date.now() - this.lastMicrosoftSyncAt < 120000) {
      this.loadUpcomingMeetings();
      return;
    }
    this.meetingsSyncing = true;
    this.meetingsLoading = true;
    const finish = () => {
      this.meetingsSyncing = false;
      this.meetingsLoading = false;
      this.loadUpcomingMeetings();
    };
    this.meetingService
      .syncMicrosoftCalendar()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.lastMicrosoftSyncAt = Date.now();
          finish();
        },
        error: finish,
      });
  }

  loadUpcomingMeetings(): void {
    if (this.meetingsLoading) return;
    const now = new Date();
    const to = new Date(now);
    to.setDate(to.getDate() + 90);
    to.setHours(23, 59, 59, 999);

    this.meetingsLoading = true;
    this.meetingsError = '';
    this.meetingService
      .list({
        mine: true,
        active: true,
        start_from: now.toISOString(),
        start_to: to.toISOString(),
        order: 'asc',
        page: 1,
        limit: 12,
      })
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => (this.meetingsLoading = false)),
      )
      .subscribe({
        next: (result) => {
          this.upcomingMeetings = result.meetings
            .filter((meeting) => new Date(meeting.end_at).getTime() >= Date.now())
            .slice(0, 6);
          this.upcomingMeetingsTotal = Number(
            result.meta?.['total'] ?? this.upcomingMeetings.length,
          );
        },
        error: () => {
          this.upcomingMeetings = [];
          this.upcomingMeetingsTotal = 0;
          this.meetingsError = 'No se pudieron consultar las próximas reuniones.';
        },
      });
  }

  createMeeting(event?: MouseEvent): void {
    event?.stopPropagation();
    this.meetingsOpen = false;
    this.meetingModalMode = 'create';
    this.meetingModalExternalId = null;
    this.meetingModalInitialData = null;
    this.meetingModalOpen = true;
  }

  manageMeeting(meeting: Meeting, event?: MouseEvent): void {
    event?.stopPropagation();
    this.meetingsOpen = false;
    this.meetingModalMode =
      meeting.permissions?.can_manage && meeting.status === 'SCHEDULED'
        ? 'edit'
        : 'view';
    this.meetingModalExternalId = meeting.external_id;
    this.meetingModalInitialData = null;
    this.meetingModalOpen = true;
  }

  viewAllMeetings(event?: MouseEvent): void {
    event?.stopPropagation();
    this.meetingsOpen = false;
    this.router.navigate(['/meetings']);
  }

  onMeetingModalSaved(_event: MeetingModalSavedEvent): void {
    this.loadUpcomingMeetings();
  }

  onMeetingModalClosed(_event: MeetingModalClosedEvent): void {
    this.meetingModalOpen = false;
    this.meetingModalExternalId = null;
    this.meetingModalInitialData = null;
  }

  meetingProviderLabel(meeting: Meeting): string {
    const labels: Record<Meeting['provider'], string> = {
      MICROSOFT_TEAMS: 'Microsoft Teams',
      MICROSOFT_OUTLOOK: 'Microsoft Outlook',
      GOOGLE_MEET: 'Google Meet',
      ZOOM: 'Zoom',
      NONE: meeting.meeting_type === 'PRESENTIAL' ? 'Presencial' : 'ZIVO',
    };
    return labels[meeting.provider];
  }

  meetingProviderIcon(meeting: Meeting): string {
    return {
      MICROSOFT_TEAMS: 'video_camera_front',
      MICROSOFT_OUTLOOK: 'event',
      GOOGLE_MEET: 'duo',
      ZOOM: 'videocam',
      NONE: meeting.meeting_type === 'PRESENTIAL' ? 'meeting_room' : 'event',
    }[meeting.provider];
  }

  isMeetingToday(meeting: Meeting): boolean {
    const date = new Date(meeting.start_at);
    const today = new Date();
    return (
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate()
    );
  }

  cambiarFiltro(filtro: 'todas' | 'no_leidas') {
    this.filtro = filtro;
    this.notificationsService.loadPreview(this.filtro);
  }

  // abrirNotificacion(n: any) {
  //   if (!n.is_read) {
  //     this.notificationsService.markAsRead(n.id).subscribe(() => {
  //       n.is_read = true;
  //       this.notificacionesNoLeidas--;
  //     });
  //   }

  //   if (n.notification?.link_url) {
  //     this.router.navigateByUrl(n.notification.link_url);
  //   }

  //   this.mostrarNotificaciones = false;
  // }

  abrirNotificacion(n: any) {
    if (!n.is_read) {
      this.notificationsService.markAsRead(n.id).subscribe(() => {
        n.is_read = true;
        this.notificacionesNoLeidas--;
      });
    }

    if (n.notification?.link_url) {
      const url = new URL(n.notification.link_url, window.location.origin);

      const path = url.pathname;
      const queryParams: any = {};

      url.searchParams.forEach((value, key) => {
        queryParams[key] = value;
      });

      this.router.navigate([path], {
        queryParams,
        queryParamsHandling: 'merge', //
      });
    }

    this.mostrarNotificaciones = false;
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.mostrarNotificaciones = false;
    this.meetingsOpen = false;

    this.avatarAssistantService.unlockSound();
  }

  filtrarNoLeidas() {
    this.filtro = 'no_leidas';
    this.notificationsService.setPreviewFilter(this.filtro);
  }

  filtrarTodas() {
    this.filtro = 'todas';
    this.notificationsService.setPreviewFilter(this.filtro);
  }

  marcarTodas() {
    this.notificationsService.markAllPreviewAsRead().subscribe(() => {
      this.notificationsService.clearUnreadPreviewLocal();
      this.notificacionesNoLeidas = 0;
    });
  }

  // cargarNotificaciones(reset = false) {
  //   if (this.loading || !this.hasMore) return;

  //   this.loading = true;

  //   if (reset) {
  //     this.page = 1;
  //     this.notificaciones = [];
  //     this.hasMore = true;
  //   }

  //   this.notificationsService
  //     .getMyNotifications(this.page, this.limit)
  //     .subscribe((res) => {
  //       const nuevas = res.data;

  //       if (nuevas.length === 0) {
  //         this.hasMore = false;
  //       } else {
  //         this.notificaciones.push(...nuevas);
  //         this.page++;
  //       }

  //       this.notificacionesNoLeidas = this.notificaciones.filter(
  //         (n) => !n.is_read,
  //       ).length;

  //       this.loading = false;
  //     });
  // }
  // onScroll(event: any) {
  //   const el = event.target;

  //   if (el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
  //     this.cargarNotificaciones();
  //   }
  // }

  playNotificationSound(): void {
    void this.avatarAssistantService.playSound('notification');
  }

  abrirDesdeToast(n: UiNotification) {
    if (!n.link) return;

    const url = new URL(n.link, window.location.origin);
    const path = url.pathname;
    const queryParams: any = {};

    url.searchParams.forEach((value, key) => {
      queryParams[key] = value;
    });

    this.router.navigate([path], {
      queryParams,
      queryParamsHandling: 'merge',
    });

    // cerrar solo la que se clickeó
    this.uiNotifications = this.uiNotifications.filter((x) => x.id !== n.id);
  }

  cerrarToast(n: UiNotification, event?: MouseEvent) {
    if (event) event.stopPropagation();

    n.closing = true;

    setTimeout(() => {
      this.uiNotifications = this.uiNotifications.filter((x) => x.id !== n.id);
    }, 250);
  }

  showUiNotification(notif: any) {
    const item: UiNotification = {
      id: ++this.notifId,
      message: notif?.notification?.message || 'Nueva notificación',
      link: notif?.notification?.link_url,
      createdAt: new Date(),
      closing: false,
    };

    // 🔊 sonido (no bloquea nada)
    this.playNotificationSound();

    // ➕ agregar al overlay
    this.uiNotifications.unshift(item);

    // ⏱️ auto cerrar a los 6s (opcional)
    setTimeout(() => {
      this.cerrarToast(item);
    }, 20000);
  }

  irLMS() {
    this.authService.getMoodleSSO().subscribe({
      next: (res) => {
        if (res?.url) {
          window.open(res.url, '_blank');
        }
      },
      error: () => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo abrir la plataforma de capacitaciones',
        });
      },
    });
  }
  irMisAsistencias(): void {
    if (!this.employeeExternalId) return;

    this.menuAbierto = false;

    this.router.navigate(['/mis-asistencias']);
  }

  loadMyLodging(event?: MouseEvent): void {
    event?.stopPropagation();

    if (
      !this.employeeExternalId ||
      this.myLodgingLoading
    ) {
      return;
    }

    this.myLodgingLoading = true;
    this.myLodgingError = '';

    this.http
      .get<any>(
        '/api/recursos-humanos/personnel-entries/services/lodgings/me',
      )
      .pipe(
        takeUntil(this.destroy$),
        finalize(
          () =>
            (this.myLodgingLoading = false),
        ),
      )
      .subscribe({
        next: (response) => {
          this.myLodgingData =
            response?.data || null;
        },
        error: () => {
          this.myLodgingData = null;
          this.myLodgingError =
            'No se pudo consultar tu hospedaje.';
        },
      });
  }

  myLodgingWorkLabel(): string {
    const state =
      this.myLodgingData?.work_state;

    if (state === 'WORK') return 'Trabajo';
    if (state === 'REST') return 'Descanso';
    return 'Sin planificación';
  }

  myLodgingPlace(): string {
    const assignment =
      this.myLodgingData?.assignment;

    if (!assignment) {
      return 'Sin hospedaje asignado';
    }

    if (
      assignment.capacity_mode ===
      'GENERIC'
    ) {
      return assignment.establishment;
    }

    return [
      assignment.establishment,
      assignment.room,
      assignment.bed
        ? `Cama ${assignment.bed}`
        : null,
    ]
      .filter(Boolean)
      .join(' · ');
  }

  openDirectoryModal(): void {
    this.directoryOpen = true;
    this.directoryIncludeInactive = false;
    this.directorySearch.setValue('', { emitEvent: false });
    this.directoryCopyMessage = '';
    this.loadDirectoryUsers(1);
  }

  onDirectoryIncludeInactiveChange(event: Event): void {
    this.directoryIncludeInactive = (event.target as HTMLInputElement).checked;
    this.loadDirectoryUsers(1);
  }

  loadDirectoryUsers(page = 1): void {
    if (!this.directoryOpen || page < 1 || (this.directoryTotalPages && page > this.directoryTotalPages && page !== 1)) return;
    this.directoryRequest?.unsubscribe();
    this.directoryPage = page;
    this.directoryUsers = [];
    this.directoryError = '';
    this.loadingDirectory = true;
    this.directoryRequest = this.userService.buscarDirectorioUsuarios({
      search: this.directorySearch.value || '',
      page,
      limit: this.directoryLimit,
      includeInactive: this.directoryIncludeInactive,
    }).pipe(takeUntil(this.destroy$)).subscribe({
      next: (result) => {
        this.directoryUsers = (result.usuarios || []).map((user: any) => ({
          ...user,
          contactos: (Array.isArray(user.contactos) ? user.contactos : [])
            .filter((contact: any) => {
              const value = String(contact?.value ?? '').trim();
              return value && !['-', 'null', 'undefined', 'sin registrar'].includes(value.toLowerCase());
            }),
        }));
        this.directoryTotal = result.total || 0;
        this.directoryTotalPages = result.totalPages || 0;
        this.loadingDirectory = false;
      },
      error: () => {
        this.loadingDirectory = false;
        this.directoryTotal = 0;
        this.directoryTotalPages = 0;
        this.directoryError = 'No se pudo cargar el directorio. Intente nuevamente.';
      },
    });
  }

  highlight(text: string): string {
    const safe = String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
    const escaped = (word: string) => Array.from(word).map((char) =>
      '\\.^$*+?()[]{}|'.includes(char) ? '\\' + char : char).join('');
    const words = (this.directorySearch.value || '')
      .trim().split(/\s+/).filter(Boolean).map(escaped);
    return words.length
      ? safe.replace(new RegExp('(' + words.join('|') + ')', 'gi'), '<mark>$1</mark>')
      : safe;
  }

  // Cuando el correo principal es provisional, priorizar un contacto de correo real.
  directoryEmail(user: any): string {
    const primary = String(user?.correo || '').trim();
    const extra = (user?.contactos || [])
      .filter((contact: any) => contact.type === 'email')
      .map((contact: any) => String(contact.value || '').trim())
      .find((email: string) => email && !email.endsWith('@pending.zivo.local'));
    return primary && !primary.endsWith('@pending.zivo.local')
      ? primary
      : extra || primary;
  }

  // El backend aplica el permiso al campo "telefono"; el frontend no debe
  // ocultar un teléfono que el endpoint ya ha autorizado y devuelto.
  // Los contactos adicionales se muestran por separado desde "contactos".
  directoryPhone(user: any): string {
    const phone = String(user?.telefono ?? '').trim();
    return phone && !['-', 'n/a', 'null', 'undefined', 'sin registrar'].includes(phone.toLowerCase())
      ? phone
      : '';
  }

  async copyDirectoryValue(value: unknown, label: string): Promise<void> {
    const text = String(value ?? '').trim();
    if (!text || text === '-') return;
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard API no disponible');
      await navigator.clipboard.writeText(text);
    } catch {
      const field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      let copied = false;
      try { copied = document.execCommand('copy'); }
      finally { document.body.removeChild(field); }
      if (!copied) {
        this.directoryCopyMessage = 'No fue posible copiar. Compruebe los permisos del navegador.';
        return;
      }
    }
    this.directoryCopyMessage = label + ' copiado al portapapeles.';
  }

  @HostListener('document:keydown', ['$event'])
  handleEscape(event: KeyboardEvent): void {
    if (event.key !== 'Escape') return;
    if (this.digitalCardOpen) {
      this.closeDigitalCard();
      return;
    }
    if (this.directoryOpen) {
      this.closeDirectory();
    }
  }

  closeDirectory(): void {
    this.directoryOpen = false;
    this.directoryRequest?.unsubscribe();
    this.directorySearch.setValue('', { emitEvent: false });
    this.directoryCopyMessage = '';
  }

  //verificar si tengo el permiso /view/phone/users
  canViewPhone(): void {
    this.viewPhone = this.authService
      .getPermisos()
      .includes('view-phone-users');
    console.log(this.viewPhone);
  }

  irEROLY (): void {
    if (this.cargandoVantix) return;

    if (!this.user_id) {
      Swal.fire({
        icon: 'warning',
        title: 'Usuario no identificado',
        text: 'No se pudo identificar al usuario autenticado.',
      });

      return;
    }
    
    this.cargandoVantix = true;
    
    // return;
    this.userExternalService
      .accessVantix(this.user_id, '/home')
      .pipe(
        finalize(() => {
          this.cargandoVantix = false;
        }),
      )
      .subscribe({
        next: (response) => {
          const loginUrl = response?.data?.login_url;

          if (!loginUrl) {
            Swal.fire({
              icon: 'error',
              title: 'Acceso no disponible',
              text: 'Vantix no devolvió una dirección de acceso.',
            });

            return;
          }

          // Abre Vantix en la misma pestaña.
          window.location.assign(loginUrl);
        },
        error: (error) => {
          console.error('Error al acceder a Vantix:', error);

          Swal.fire({
            icon: 'error',
            title: 'No se pudo acceder a Vantix',
            text:
              error?.error?.message ||
              'Ocurrió un error al sincronizar el usuario.',
          });
        },
      });
  }

  openDigitalCard(event?: MouseEvent): void {
    event?.stopPropagation();

    // Cerramos los demás elementos del top bar.
    this.mostrarNotificaciones = false;
    this.meetingsOpen = false;
    this.menuAbierto = false;

    if (!this.digitalCardOpen) {
      this.previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }

    this.digitalCardOpen = true;
    this.digitalCardError = '';

    if (!this.digitalCardData) {
      this.loadDigitalCard();
    }
  }

  closeDigitalCard(event?: MouseEvent): void {
    event?.stopPropagation();

    this.digitalCardOpen = false;
    document.body.style.overflow = this.previousBodyOverflow;
  }

  private loadDigitalCard(): void {
    if (this.digitalCardLoading) return;

    this.digitalCardLoading = true;
    this.digitalCardError = '';

    this.userService.getDigitalCard().subscribe({
        next: (response) => {
          this.digitalCardData = response;
          this.digitalCardLoading = false;
        },
        error: (error) => {
          console.error(
            'No se pudo cargar el carnet digital.',
            error,
          );

          this.digitalCardLoading = false;

          this.digitalCardError =
            error?.error?.error ||
            'No se pudo cargar el carnet digital.';
        },
      });
  }

  retryDigitalCard(event?: MouseEvent): void {
    event?.stopPropagation();

    this.digitalCardData = null;
    this.loadDigitalCard();
  }

  async downloadDigitalCard(): Promise<void> {
    const node = this.digitalCardElement?.nativeElement;

    if (
      !node ||
      !this.digitalCardData ||
      this.digitalCardDownloading
    ) {
      return;
    }

    this.digitalCardDownloading = true;
    this.digitalCardError = '';

    try {
      const dataUrl = await toPng(node, {
        cacheBust: true,
        pixelRatio: 3,
        backgroundColor: '#ffffff',
        style: {
          margin: '0',
        },
      });

      const link = document.createElement('a');

      link.download =
        `Carnet_ZIVO_${this.safeDigitalCardFileName(
          this.digitalCardData.full_name,
        )}.png`;

      link.href = dataUrl;
      link.click();
    } catch (error) {
      console.error(
        'No se pudo descargar el carnet digital.',
        error,
      );

      this.digitalCardError =
        'No se pudo generar la imagen del carnet. Intente nuevamente.';
    } finally {
      this.digitalCardDownloading = false;
    }
  }

  private safeDigitalCardFileName(value: string): string {
    return String(value || 'USUARIO')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .toUpperCase();
  }
}
